import React, { useState } from "react";
import "../components/App.css";
import axios from "axios";
import { API_BASE_URL } from "../config/config";
import {
  Container,
  MenuItem,
  InputLabel,
  TextField,
  Button,
  Box,
  Modal,
} from "@mui/material";
import { Spinner, Alert } from "react-bootstrap";
import { useActiveCareUser } from "../hooks/useActiveCareUser";

const payoutModeModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const RaiseClaim = () => {
  const { userDetails } = useActiveCareUser();
  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [selectedClaimType, setSelectedClaimType] = useState("");
  const [claimReason, setClaimReason] = useState("");
  const [selectedImages, setSelectedImages] = useState(null);
  const [approvedCareValue, setApprovedCareValue] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPayoutModeModal, setShowPayoutModeModal] = useState(false);
  const [payoutModeDetails, setPayoutModeDetails] = useState({
    accNum: "",
    accName: "",
    bankName: "",
    swiftCode: "",
    branchAdd: "",
    contactNum: "",
  });

  const handleServiceTypeChange = (event) => {
    setSelectedServiceType(event.target.value);
    setSelectedClaimType("");
  };

  const handleClaimTypeChange = (event) => {
    console.log("Selected Claim Type:", event.target.value);
    setSelectedClaimType(event.target.value);
  };

  const handleReasonChange = (event) => {
    setClaimReason(event.target.value);
  };

  const handleImageChange = (event) => {
    const files = event.target.files;
    setSelectedImages([...files]);
  };

  const handleApprovedCareValueChange = (event) => {
    setApprovedCareValue(event.target.value);
  };

  const handlePayoutModeModalOpen = () => {
    setShowPayoutModeModal(true);
  };

  const handlePayoutModeModalClose = () => {
    setShowPayoutModeModal(false);
  };

  const handlePayoutModeDetailsChange = (event) => {
    const { name, value } = event.target;
    setPayoutModeDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePayoutModeSave = () => {
    handlePayoutModeModalClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setShowLoader(true);
      const token = localStorage.getItem("care_token");
      const formData = new FormData();
      formData.append("id", userDetails._id);
      formData.append("claim_type", selectedClaimType);
      formData.append("details", claimReason);
      formData.append("amount", approvedCareValue);
      selectedImages.forEach((image) => {
        formData.append(`images`, image);
      });
      formData.append("accNum", payoutModeDetails.accNum);
      formData.append("bankName", payoutModeDetails.bankName);
      formData.append("accName", payoutModeDetails.accName);
      formData.append("swiftCode", payoutModeDetails.swiftCode);
      formData.append("branchAdd", payoutModeDetails.branchAdd);
      formData.append("contactNum", payoutModeDetails.contactNum);
      console.log(formData);
      await axios.post(`${API_BASE_URL}/claim`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setShowLoader(false);
      setShowSuccess(true);
      setSelectedServiceType("");
      setSelectedClaimType("");
      setClaimReason("");
      setSelectedImages(null);
      setApprovedCareValue("");
    } catch (error) {
      console.error("Error raising claim:", error.response.data.error);
      setShowLoader(false);
      setShowError(true);
      setErrorMessage(error.response.data.error);
    }
  };

  return (
    <>
      <Container>
        <div className="claim-container">
          <h3 style={{ marginBottom: "2rem" }}>
            Raise Your Claim Query Ticket
          </h3>
          <form onSubmit={handleSubmit}>
            <label id="service-type-label">Select Service Category</label>
            <select
              id="service-type-select"
              value={selectedServiceType}
              onChange={handleServiceTypeChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                marginBottom: "20px",
              }}
            >
              <MenuItem value="">Select</MenuItem>
              {[
                ...new Set(
                  userDetails.services.map((service) => service.category)
                ),
              ].map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
            <label id="claim-type-label">Select Claim Type</label>
            <br />
            <select
              id="claim-type-select"
              value={selectedClaimType}
              onChange={handleClaimTypeChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
              }}
            >
              <MenuItem value="">Select</MenuItem>
              {userDetails.services.map(
                (service) =>
                  service.category === selectedServiceType && (
                    <>
                      {service.category === "Mobile Phones" ||
                      service.category === "Tablets" ||
                      service.category === "Laptop" ||
                      service.category === "Desktop" ||
                      service.category === "Printer" ||
                      service.category === "Projector" ||
                      service.category === "Digital Camera" ||
                      service.category === "CCTV Camera" ||
                      service.category === "Speakers" ||
                      service.category === "Television" ||
                      service.category === "Microwave" ||
                      service.category === "Refrigerator" ||
                      service.category === "Washing Machine" ||
                      service.category === "Vacuum Cleaner" ||
                      service.category === "Water Purifier" ||
                      service.category === "Mixer Grinder" ||
                      service.category === "Dishwasher" ||
                      service.category === "Air Conditioner" ||
                      service.category === "Coffee Maker" ||
                      service.category === "Electric Chimney" ||
                      service.category === "Hair Dryer" ||
                      service.category === "Health Care Devices" ||
                      service.category === "Fitness Equipments" ||
                      service.category === "Eyesight Glasses" ||
                      service.category === "Sunglasses" ||
                      service.category === "Watches" ||
                      service.category === "Motorhome" ||
                      service.category === "Jet Ski" ||
                      service.category === "Boats" ||
                      service.category === "Snowmobile" ||
                      service.category === "Bicycle" ||
                      service.category === "Sofa Sets" ||
                      service.category === "Chairs" ||
                      service.category === "Coffee and End Tables" ||
                      service.category === "Seats" ||
                      service.category === "Recliners" ||
                      service.category === "Agro Equipments" ? (
                        <>
                          <option value="Service Cost">Service Cost</option>
                          <option value="Timely Maintenance">
                            Timely Maintenance
                          </option>
                          <option value="Part Replacement">
                            Part Replacement
                          </option>
                          <option value="Water Damage">Water Damage</option>
                          <option value="Theft & Lost">Theft & Lost</option>
                          <option value="Outer Body Change">
                            Outer Body Change
                          </option>
                          <option value="Fully Damage (Return Claim)">
                            Fully Damage (Return Claim)
                          </option>
                        </>
                      ) : service.category === "Domestic Trip" ||
                        service.category === "Hotel Stays" ||
                        service.category === "Local Ride" ? (
                        <>
                          <option value="Theft">Theft</option>
                          <option value="Attack">Attack</option>
                          <option value="Fire Accident">Fire Accident</option>
                          <option value="Harassment">Harassment</option>
                          <option value="Accident">Accident</option>
                          <option value="Minor Injury">Minor Injury</option>
                          <option value="Natural Calamity">
                            Natural Calamity
                          </option>
                          <option value="Other">Other</option>
                        </>
                      ) : service.category === "Wedding" ||
                        service.category === "Corporate Events" ||
                        service.category === "Private Events" ? (
                        <>
                          <option value="Theft">Theft</option>
                          <option value="Attack">Attack</option>
                          <option value="Fire Accident">Fire Accident</option>
                          <option value="Accident">Accident</option>
                          <option value="Natural Calamity">
                            Natural Calamity
                          </option>
                          <option value="Other">Other</option>
                        </>
                      ) : service.category === "Warehouse Stock" ||
                        service.category === "Retail" ||
                        service.category === "Logistics" ? (
                        <>
                          <option value="Theft">Theft</option>
                          <option value="Attack">Attack</option>
                          <option value="Fire Accident">Fire Accident</option>
                          <option value="Life Loss">Life Loss</option>
                          <option value="Physical Injuries">
                            Physical Injuries
                          </option>
                          <option value="Natural Calamity">
                            Natural Calamity
                          </option>
                          <option value="Other">Other</option>
                        </>
                      ) : null}
                    </>
                  )
              )}
            </select>
            <Box mt={4}>
              <InputLabel htmlFor="claim-reason">
                In Detail (Type the reason of claim)
              </InputLabel>
              <TextField
                id="claim-reason"
                multiline
                rows={5}
                value={claimReason}
                onChange={handleReasonChange}
                variant="outlined"
                fullWidth
              />
            </Box>
            <Box mt={4}>
              <InputLabel htmlFor="images">
                Upload Supporting Documents (JPG Only)
              </InputLabel>
              <input
                id="images"
                name="images"
                type="file"
                accept="image/jpeg"
                multiple
                onChange={handleImageChange}
              />
            </Box>
            <Box mt={4}>
              <InputLabel htmlFor="approved-care-value">
                How much is your approved Care Value?
              </InputLabel>
              <TextField
                id="approved-care-value"
                value={approvedCareValue}
                onChange={handleApprovedCareValueChange}
                variant="outlined"
                fullWidth
              />
            </Box>
            <Box mt={4} textAlign="center">
              <Button
                variant="contained"
                onClick={handlePayoutModeModalOpen}
                style={{ color: "white", backgroundColor: "#d31b2d" }}
              >
                Fill Claim Payout Mode Details
              </Button>
            </Box>
            <Box mt={4} style={{ textAlign: "center", marginBottom: "2rem" }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={showLoader}
              >
                Submit Request
              </Button>
            </Box>
          </form>
          {showLoader && <Spinner animation="border" />}
          {showSuccess && (
            <Alert
              variant="success"
              onClose={() => setShowSuccess(false)}
              dismissible
            >
              Claim request successful!
            </Alert>
          )}
          {showError && (
            <Alert
              variant="danger"
              onClose={() => setShowError(false)}
              dismissible
            >
              Error: {errorMessage}
            </Alert>
          )}
        </div>
      </Container>
      <Modal
        open={showPayoutModeModal}
        onClose={handlePayoutModeModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...payoutModeModalStyle }}>
          <h2 id="modal-modal-title">Claim Payout Mode Details</h2>
          <TextField
            id="bankName"
            name="bankName"
            label="Bank Name"
            value={payoutModeDetails.bankName}
            onChange={handlePayoutModeDetailsChange}
            fullWidth
            required
            sx={{ mt: 2 }}
          />
          <TextField
            id="accName"
            name="accName"
            label="Account Holder's Name"
            value={payoutModeDetails.accName}
            onChange={handlePayoutModeDetailsChange}
            fullWidth
            required
            sx={{ mt: 2 }}
          />
          <TextField
            id="accNum"
            name="accNum"
            label="Account Number"
            value={payoutModeDetails.accNum}
            onChange={handlePayoutModeDetailsChange}
            fullWidth
            required
            sx={{ mt: 2 }}
          />
          <TextField
            id="swiftCode"
            name="swiftCode"
            label="SWIFT Code"
            value={payoutModeDetails.swiftCode}
            onChange={handlePayoutModeDetailsChange}
            fullWidth
            required
            sx={{ mt: 2 }}
          />
          <TextField
            id="branchAdd"
            name="branchAdd"
            label="Branch Address"
            value={payoutModeDetails.branchAdd}
            onChange={handlePayoutModeDetailsChange}
            fullWidth
            required
            sx={{ mt: 2 }}
          />
          <TextField
            id="contactNum"
            name="contactNum"
            label="Contact Number"
            value={payoutModeDetails.contactNum}
            onChange={handlePayoutModeDetailsChange}
            fullWidth
            required
            sx={{ mt: 2 }}
          />
          <Box sx={{ mt: 2, textAlign: "center" }}>
            <Button
              variant="contained"
              onClick={handlePayoutModeSave}
              sx={{ mr: 2 }}
            >
              Save
            </Button>
            <Button variant="contained" onClick={handlePayoutModeModalClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default RaiseClaim;
